import t from '@rcm/i18n-client';
import type { BlockComponentProps } from 'client-react-block-renderer';
import { Col, Row } from 'forms';
import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import RequestResetEmailForm from './RequestResetEmailForm.client';
import SetNewPassword from './SetNewPassword.client';

interface Props extends BlockComponentProps<BlockData, BlockConfig> {}

interface BlockConfig {}

interface BlockData {}

const PasswordResetBlock = (props: Props) => {
  return (
    <div className="forgot-password">
      <Row>
        <Col>
          <h1>{t('Reset Password')}</h1>
        </Col>
      </Row>
      <HashRouter>
        <Switch>
          <Route exact path="/">
            <RequestResetEmailForm />
          </Route>
          <Route exact path="/set-new-password/:userId/:token/:expirationTimestamp">
            <SetNewPassword />
          </Route>
        </Switch>
      </HashRouter>
    </div>
  );
};

export default PasswordResetBlock;
